<div class="mobile-app">
  <!-- Header móvil -->
  @if (showHeader()) {
    <app-header></app-header>
  }

  <!-- Contenido principal -->
  <main class="mobile-content">
    <router-outlet />
  </main>

  <!-- Loading overlay -->
  @if (isLoading()) {
    <div class="loading-overlay">
      <div class="loading-spinner"></div>
    </div>
  }
</div>